import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type EmailState = CommonTableState;

const initialState: EmailState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {},
        columnVisibility: {},
        columnOrder: [],
        density: "compact",
    },
};

export const emailSlice = createSlice({
    name: "email",
    initialState: initialState,
    reducers: {
        updateEmailTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateEmailTableState } = emailSlice.actions;

export default emailSlice.reducer;
